export default "__VITE_ASSET__adf20a06__"